import { render } from "./BrandMojedelo.vue?vue&type=template&id=67e50a13"
import script from "./BrandMojedelo.vue?vue&type=script&lang=ts"
export * from "./BrandMojedelo.vue?vue&type=script&lang=ts"

import "./BrandMojedelo.vue?vue&type=style&index=0&id=67e50a13&lang=scss"
script.render = render

export default script